// extracted by mini-css-extract-plugin
export default {"alerttitleBox":"index_alerttitleBox_zpgsG","alerttitle":"index_alerttitle_AbKpR","alertcontent":"index_alertcontent_-OEkh"};